module.exports = __webpack_public_path__ + "static/media/red-light.8b702ddc.svg";